<section [formGroup]="current_status" fxLayout="column" fxLayoutGap="0px">
  <div fxLayout="row" fxLayoutGap="40px" fxLayout.xs="column" fxLayoutGap.xs="8px" style="min-width: 350px;">
    <div fxLayout="column" fxLayoutGap="8px" style="min-width: 350px;">
      <mat-form-field class="standard" *ngIf="employment_status === 'balik_manggagawa'">
        <app-date-picker formControlName="datetime_to_work"
                        placeholder="Scheduled flight back to work abroad" required
                        [min]="_6monthsAgo" [max]="_15yearsFromNow" yearOrdering="asc"
                        touchUi="true"></app-date-picker>
        <mat-error *ngIf="current_status.get('datetime_to_work').hasError('required')">Required.</mat-error>
      </mat-form-field>

      <mat-form-field class="standard" *ngIf="employment_status === 'working_flyback'">
        <app-date-picker formControlName="datetime_to_philippines" required
                        placeholder="Scheduled flight to Philippines"
                        [min]="_6monthsAgo" [max]="_15yearsFromNow" yearOrdering="asc"
                        touchUi="true"></app-date-picker>
        <mat-error *ngIf="current_status.get('datetime_to_philippines').hasError('required')">Required.</mat-error>
      </mat-form-field>

      <mat-form-field  class="standard" *ngIf="['done_requirements', 'sea_signed'].includes(employment_status)">
        <app-date-picker formControlName="tentative_departure_date" required
                        placeholder="Tentative flight date"
                        [min]="_6monthsAgo" [max]="_15yearsFromNow" yearOrdering="asc"
                        touchUi="true"></app-date-picker>
        <mat-error *ngIf="current_status.get('tentative_departure_date').hasError('required')">Required.</mat-error>
      </mat-form-field>
    </div>

    <div fxLayout="column" fxLayoutGap="0px" fxFlex="50">
      <!-- empty div to balance columns -->
    </div>
  </div>

  <div fxLayout="row" fxLayoutGap="40px" fxLayout.xs="column" fxLayoutGap.xs="8px">
    <div 
      *ngIf="(employment_type.value === 'land' && employment_channel.value === 'balik_manggagawa' && employment_status) || (employment_type.value === 'sea' && employment_status === 'sea_onboard')"
      fxLayout="column" fxLayoutGap="8px" style="min-width: 350px;">
      <mat-form-field>
        <app-date-picker formControlName="datetime_contract_end"
                        placeholder="Contract end date"
                        [min]="_6monthsAgo" [max]="_15yearsFromNow" yearOrdering="asc"
                        touchUi="true" required></app-date-picker>
        <mat-error *ngIf="current_status.get('datetime_contract_end').hasError('required')">Required.</mat-error>                
      </mat-form-field>
    </div>
    <div *ngIf="employment_type.value === 'land' && employment_channel.value === 'balik_manggagawa'" class="checkbox-col" fxLayout="column" fxLayoutGap="8px" fxFlex="50">
      <mat-checkbox color="primary" formControlName="unlimited_contract">
        Unlimited contract
      </mat-checkbox>
    </div>
  </div>
</section>
